import { useEffect, useMemo, useState } from "react";

export function useIsInViewportOnce(ref) {
  const [isIntersecting, setIsIntersecting] = useState(false);

  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setIsIntersecting(true)
        }
      }
      ),
    [],
  );

  useEffect(() => {
    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, observer]);

  return isIntersecting;
}

export function useIsUSA() {
  const [isAllowed, setIsAllowed] = useState(null);

  useEffect(() => {
    fetch('https://api.cyberlift.ai/v1/geo')
      .then((res) => res.json())
      .then((data) => {
        const country = data.country_code;
        setIsAllowed(country !== 'US');
      })
      .catch(() => {
        setIsAllowed(true);
      });
  }, []);

  return isAllowed;
}